import { render } from "./InputDropzone.vue?vue&type=template&id=6629b2c6"
import script from "./InputDropzone.vue?vue&type=script&lang=js"
export * from "./InputDropzone.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__